import { HolderOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "antd";
import {
  ButtonFunction,
} from "../../../services/ApiTypes.ts";
import { ButtonItem } from "./ButtonItem.ts";
import "./SortableButtonList.css";



const SortableListItem: React.FC<{
  buttonItem: ButtonItem;
  onDelete: (buttonItem: ButtonItem) => void;
  onEdit: (item: ButtonItem) => void;
}> = ({ buttonItem: item, onDelete, onEdit }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: item.id,
    });

  if (item.button.function === ButtonFunction.Submit) {
    return (
      <div className="draggable-box">
        <span className="submit-span">{item.button.text}</span>
        <Button className="edit-button" onClick={(e) => onEdit(item)}>Edit</Button>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition
      }}
      className="draggable-box"
      {...attributes}
      data-testid={"button-"+item.id}
    >
      <HolderOutlined className="holder-outlined-icon" 
      {...listeners}/>

      <span>{item.button.text}</span>
      <Button className="edit-button" onClick={(e) => onEdit(item)} data-testid={"buttonEditButton-"+item.id}>
        Edit
      </Button>
      <Button
        icon={<DeleteOutlined />}
        danger
        onClick={(e) => onDelete(item)}
        data-testid={"buttonDeleteButton-"+item.id}
      />
    </div>
  );
};
export default SortableListItem;
